export default "__VITE_ASSET__DDESkNYh__"